import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const slides = [
    {
        title: "प्रीमियम गुणवत्ता",
        desc: "चुनिंदा और उच्च गुणवत्ता वाले कच्चे मसालों से तैयार शुद्ध मसाले।",
        image: "/images/home/choose/kacha.jpg",
    },
    {
        title: "स्वच्छ निर्माण प्रक्रिया",
        desc: "आधुनिक मशीनों और पूरी तरह स्वच्छ वातावरण में निर्मित मसाले।",
        image: "/images/home/choose/machine.jpg",
    },
    {
        title: "असली भारतीय स्वाद",
        desc: "परंपरागत स्वाद जो हर व्यंजन को खास और लाजवाब बनाता है।",
        image: "/images/home/choose/taste.jpg",
    },
    {
        title: "विश्वसनीय ब्रांड",
        desc: "सालों से लोगों का भरोसा और गुणवत्ता की पहचान।",
        image: "/images/home/choose/trusted.jpg",
    },
];

export default function WhyChooseUsSlider() {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 3000);
        return () => clearInterval(interval);
    }, []);

    return (
        <section className="pt-10 pb-6 md:pt-14 md:pb-8">
            <div className="max-w-7xl mx-auto px-4 md:px-6 flex justify-center">

                <div
                    className="
                        w-full
                        max-w-5xl
                        bg-black/55
                        backdrop-blur-sm
                        rounded-3xl
                        shadow-2xl
                        px-6 md:px-12
                        py-8 md:py-10
                    "
                >
                    {/* Heading */}
                    <div className="text-center mb-8">
                        <h2 className="text-3xl md:text-5xl font-extrabold text-[#ffb3b8]">
                            Balaji Masale क्यों चुनें?
                        </h2>
                        <p className="mt-3 text-gray-200 text-sm md:text-lg">
                            गुणवत्ता, शुद्धता और स्वाद का परफेक्ट संगम
                        </p>
                    </div>

                    {/* Slider */}
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, x: 60 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: -60 }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                            className="
                                grid
                                md:grid-cols-2
                                gap-6
                                items-center
                                bg-white
                                rounded-2xl
                                shadow-xl
                                p-6 md:p-8
                            "
                        >
                            <div className="flex justify-center">
                                <img
                                    src={slides[index].image}
                                    alt={slides[index].title}
                                    className="w-full max-w-xs rounded-xl shadow-lg object-cover"
                                />
                            </div>

                            <div className="text-center md:text-left">
                                <h3 className="text-2xl md:text-3xl font-bold text-[#7a0c18]">
                                    {slides[index].title}
                                </h3>
                                <p className="mt-4 text-gray-700 text-base md:text-lg leading-relaxed">
                                    {slides[index].desc}
                                </p>
                            </div>
                        </motion.div>
                    </AnimatePresence>

                </div>
            </div>
        </section>
    );
}